module.exports = __webpack_public_path__ + "img/bus_stop_ad.5f1d4b84.jpg";